import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosServices from '../../utils/axios';

const initialState = {
    notices: [],
    cities: [],
    districts: [],
    vehicleTypes: [],
    loading: false,
    error: null,
    location: null

};

export const fetchNotices = createAsyncThunk(
    'util/fetchNotices',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosServices.get(`${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/App/get-notice`);
            
            if (response.data?.statu === 200) {
                return response.data.data || [];
            }
            
            return rejectWithValue(response.data?.exceptions?.[0] || 'Duyurular alınamadı');
        } catch (error) {
            return rejectWithValue(error.message || 'Duyurular yüklenirken bir hata oluştu');
        }
    }
);

export const fetchCities = createAsyncThunk(
    'util/fetchCities',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosServices.get(`${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/App/get-city`);
            
            if (response.data?.statu === 200) {
                return response.data.data || [];
            }
            
            return rejectWithValue(response.data?.exceptions?.[0] || 'Şehirler alınamadı');
        } catch (error) {
            return rejectWithValue(error.message || 'Şehirler yüklenirken bir hata oluştu');
        }
    }
);

export const fetchDistricts = createAsyncThunk(
    'util/fetchDistricts',
    async (idCity, { rejectWithValue }) => {
        try {
            const response = await axiosServices.get(`${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/App/get-district?idCity=${idCity}`);
            
            if (response.data?.statu === 200) {
                return response.data.data || [];
            }
            
            return rejectWithValue(response.data?.exceptions?.[0] || 'İlçeler alınamadı');
        } catch (error) {
            return rejectWithValue(error.message || 'İlçeler yüklenirken bir hata oluştu');
        }
    }
);

export const fetchVehicleTypes = createAsyncThunk(
    'util/fetchVehicleTypes',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosServices.get(`${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/App/get-vehicle-type`);

            if (response.data?.statu === 200) {
                return response.data.data || [];
            }

            return rejectWithValue(response.data?.exceptions?.[0] || 'Araç tipleri alınamadı');
        } catch (error) {
            return rejectWithValue(error.message || 'Araç tipleri yüklenirken bir hata oluştu');
        }
    }
);

export const updateLocation = createAsyncThunk(
    'global/updateLocation',
    async ({idNotification, dsContractNo, location }, { rejectWithValue }) => {
        try {
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Global/update-location?idNotification=${idNotification}&dsContractNo=${dsContractNo}&location=${location}` 
            );

            if (response.data?.statu === 200) {
                return response.data.data;
            }

            // API'den gelen hata mesajını kontrol et
            const errorMessage = response.data?.exceptions?.[0]?.Message || 
                               response.data?.message || 
                               'Konum güncellenemedi';
            return rejectWithValue(errorMessage);
        } catch (error) { 
            // Network veya diğer hatalar için
            const errorMessage = error.response?.data?.exceptions?.[0]?.Message ||
                               error.response?.data?.message ||
                               error.message ||
                               'Konum güncellenirken bir hata oluştu';
            return rejectWithValue(errorMessage);
        }
    }
);

const utilSlice = createSlice({
    name: 'util',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchNotices.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchNotices.fulfilled, (state, action) => {
                state.loading = false;
                state.notices = action.payload;
                state.error = null;
            })
            .addCase(fetchNotices.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.notices = [];
            })
            .addCase(fetchCities.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCities.fulfilled, (state, action) => {
                state.loading = false;
                state.cities = action.payload;
                state.error = null;
            })
            .addCase(fetchCities.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.cities = [];
            })
            .addCase(fetchDistricts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDistricts.fulfilled, (state, action) => {
                state.loading = false;
                state.districts = action.payload;
                state.error = null;
            })
            .addCase(fetchDistricts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.districts = [];
            })
            .addCase(fetchVehicleTypes.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchVehicleTypes.fulfilled, (state, action) => {
                state.loading = false;
                state.vehicleTypes = action.payload;
                state.error = null;
            })
            .addCase(fetchVehicleTypes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.vehicleTypes = [];
            })
            .addCase(updateLocation.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateLocation.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(updateLocation.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default utilSlice.reducer; 